import { Tooltip } from "@mui/material";
import { memo } from "react";

const GeoFencePill = ({ item, color = "green", handleOnClickLocation }
    : { item: any; color?: "green" | "orange"; handleOnClickLocation: (item: any) => void }) => {
    const styles = {
        green: { background: "#E1F5EE", color: "#0F6E56", border: "1px solid #0F6E56" },
        orange: { background: "#FFF3E0", color: "#E65100", border: "1px solid #E65100" },
    };
    const label = `${item.Name}${item?.GeoFenceTypeName ? `(${item.GeoFenceTypeName})` : ""}`;


    return (
        <Tooltip title={label}>
            <span style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "3px 10px",
                borderRadius: "999px",
                fontSize: "12px",
                fontWeight: 500,
                whiteSpace: "nowrap",
                marginRight: "4px",
                marginBottom: "4px",
                cursor: "pointer",
                maxWidth: "150px",
                ...styles[color],
            }}
                onClick={() => handleOnClickLocation(item)}
            >
                <span style={{
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}>
                    {label}
                </span>

            </span>
        </Tooltip>
    );
};

export default memo(GeoFencePill);